/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPaymentSubscriptionHealthData
 */
export interface SubscriptionPaymentSubscriptionHealthData {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentSubscriptionHealthData
     */
    activePaidCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentSubscriptionHealthData
     */
    trialCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentSubscriptionHealthData
     */
    scheduledCancellationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentSubscriptionHealthData
     */
    pastDueCount?: number;
}

/**
 * Check if a given object implements the SubscriptionPaymentSubscriptionHealthData interface.
 */
export function instanceOfSubscriptionPaymentSubscriptionHealthData(value: object): value is SubscriptionPaymentSubscriptionHealthData {
    return true;
}

export function SubscriptionPaymentSubscriptionHealthDataFromJSON(json: any): SubscriptionPaymentSubscriptionHealthData {
    return SubscriptionPaymentSubscriptionHealthDataFromJSONTyped(json, false);
}

export function SubscriptionPaymentSubscriptionHealthDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPaymentSubscriptionHealthData {
    if (json == null) {
        return json;
    }
    return {
        
        'activePaidCount': json['activePaidCount'] == null ? undefined : json['activePaidCount'],
        'trialCount': json['trialCount'] == null ? undefined : json['trialCount'],
        'scheduledCancellationCount': json['scheduledCancellationCount'] == null ? undefined : json['scheduledCancellationCount'],
        'pastDueCount': json['pastDueCount'] == null ? undefined : json['pastDueCount'],
    };
}

export function SubscriptionPaymentSubscriptionHealthDataToJSON(json: any): SubscriptionPaymentSubscriptionHealthData {
    return SubscriptionPaymentSubscriptionHealthDataToJSONTyped(json, false);
}

export function SubscriptionPaymentSubscriptionHealthDataToJSONTyped(value?: SubscriptionPaymentSubscriptionHealthData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activePaidCount': value['activePaidCount'],
        'trialCount': value['trialCount'],
        'scheduledCancellationCount': value['scheduledCancellationCount'],
        'pastDueCount': value['pastDueCount'],
    };
}

